module.exports = __webpack_public_path__ + "static/media/ketogains_banner.d9502733.svg";